import { Button, Col, DatePicker, Input, message, Modal, Row } from "antd";
import { UserOutlined } from "@ant-design/icons";
import React, { useState } from "react";

import calendar from "../../../assets/icons/calendar.png";
import { controller } from "../../../controller";
import { Error } from "../../../ErrorHandeling";

export default function AddPatientModal({ showAddPatient, setShowAddPatient, onAddNewPatient }) {
  const [isCreatingPatient, setIsCreatingPatient] = useState(false);
  const [patientEmailAddress, setPatientEmailAddress] = useState("");
  const [patientPhoneNumber, setPatientPhoneNumber] = useState("");
  const [patientBirthDate, setPatientBirthDate] = useState("");
  const [patientFirstName, setPatientFirstName] = useState("");
  const [patientLastName, setPatientLastName] = useState("");
  const [patientAddress, setPatientAddress] = useState("");
  const [patientState, setPatientState] = useState("");
  const [patientCity, setPatientCity] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [formErrorsPatient, setFormErrorsPatient] = useState({});
  const [birthDayPreview, setBirthDayPreview] = useState(null);

  const createNewPatient = async () => {
    try {
      setIsCreatingPatient(true);
      const patientFirstNameValidation = await Error.NameHandling(patientFirstName);
      const patientLastNameValidation = await Error.NameHandling(patientLastName);
      const patientCityValidation = await Error.NameHandling(patientCity);
      const patientAddressValidation = await Error.SelectItem(patientAddress);
      const zipcodeValidation = await Error.SelectItem(zipcode);
      const pstateValidation = await Error.SelectItem(patientState);
      const emailOrPhoneValidation = await Error.EmailOrPhoneHandling(patientEmailAddress, patientPhoneNumber.replace(/ /g, ""));
      if (
        patientFirstNameValidation.status &&
        patientLastNameValidation.status &&
        emailOrPhoneValidation.status &&
        patientAddressValidation.status &&
        zipcodeValidation.status &&
        pstateValidation.status &&
        patientCityValidation.status
      ) {
        const response = await controller.createGuarantor(
          patientFirstName,
          patientLastName,
          patientEmailAddress,
          patientPhoneNumber.replace(/ /g, ""),
          patientCity,
          patientBirthDate,
          patientAddress,
          patientState,
          zipcode
        );
        if (response.status < 250) {
          setFormErrorsPatient({
            Zipcode: { massage: "", status: true },
            pState: { massage: "", status: true },
            Address: { massage: "", status: true },
            BirthDate: { massage: "", status: true },
            SelectProvider: { massage: "", status: true },
            FirstName: { massage: "", status: true },
            LastName: { massage: "", status: true },
            Email: { massage: "", status: true },
            Phone: { massage: "", status: true },
            City: { massage: "", status: true },
          });
          message.success("Patient created successfully");
          onAddNewPatient(response.id);
          setShowAddPatient(false);
        } else {
          const errors = response.errors || response; // Assume errors can come directly or in an `errors` key
          let errorMessages = [];
          for (const key in errors) {
            if (errors[key] && Array.isArray(errors[key])) {
              errorMessages.push(`${errors[key].join(", ")}`);
            }
          }
          setFormErrorsPatient({
            pState: { massage: response.state ? response.state[0] : "", status: response.state ? false : true },
            Zipcode: { massage: response.zipcode ? response.zipcode[0] : "", status: response.zipcode ? false : true },
            Address: { massage: response.address ? response.address[0] : "", status: response.address ? false : true },
            BirthDate: { massage: response.birth_date ? response.birth_date[0] : "", status: response.birth_date ? false : true },
            FirstName: { massage: response.first_name ? response.first_name[0] : "", status: response.first_name ? false : true },
            LastName: { massage: response.last_name ? response.last_name[0] : "", status: response.last_name ? false : true },
            Email: { massage: response.email ? response.email[0] : "", status: response.email ? false : true },
            Phone: { massage: response.phone ? response.phone[0] : "", status: response.phone ? false : true },
            City: { massage: response.city ? response.city[0] : "", status: response.city ? false : true },
          });
        }
      } else {
        setFormErrorsPatient({
          Email: emailOrPhoneValidation.type === "email" ? emailOrPhoneValidation : { massage: "", status: true },
          FirstName: patientFirstNameValidation,
          LastName: patientLastNameValidation,
          Phone: emailOrPhoneValidation.type === "phone" ? emailOrPhoneValidation : { massage: "", status: true },
          City: patientCityValidation,
          Address: patientAddressValidation,
          Zipcode: zipcodeValidation,
          pState: pstateValidation,
        });
      }
    } catch (error) {
      console.error("Error creating new patient:", error);
      message.error("An An error occurred while creating a new patient");
    } finally {
      setIsCreatingPatient(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "patient_first_name":
        setPatientFirstName(value);
        break;
      case "patient_last_name":
        setPatientLastName(value);
        break;
      case "patient_email_address":
        setPatientEmailAddress(value);
        break;
      case "patient_phone_number":
        setPatientPhoneNumber(value);
        break;
      case "patient_city":
        setPatientCity(value);
        break;
      case "patient_address":
        setPatientAddress(value);
        break;
      case "patient_state":
        setPatientState(value);
        break;
      case "Zipcode":
        setZipcode(value);
        break;
      default:
        break;
    }
  };

  const handleBirthDateChange = (value, dateString) => {
    setBirthDayPreview(value);
    setPatientBirthDate(dateString);
  };

  return (
    <Modal
      title="Add Patient"
      open={showAddPatient}
      okText="Create"
      onCancel={() => setShowAddPatient(false)}
      className="modal-size1"
      footer={[
        <Button style={{ width: 139, height: 38 }} key="submit" type="primary" onClick={() => createNewPatient()} loading={isCreatingPatient}>
          Create
        </Button>,
      ]}
    >
      <Row gutter={[20, 20]} style={{ display: "flex", flexDirection: "row" }}>
        <Col span={12}>
          <label className="formLabel">First Name</label>
          <Input
            style={{ width: 230, height: 39, borderRadius: "8px", border: "1px solid #6B43B5" }}
            onChange={handleChange}
            className={formErrorsPatient.FirstName && formErrorsPatient.FirstName.massage !== "" ? "inputs-error" : ""}
            type="text"
            name="patient_first_name"
            placeholder="Enter Full Name"
            value={patientFirstName}
            prefix={<UserOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
          />
          {formErrorsPatient.FirstName && !formErrorsPatient.FirstName.status ? (
            <div className="error-text">{formErrorsPatient.FirstName.massage}</div>
          ) : null}
        </Col>
        <Col span={12}>
          <label className="formLabel">Last Name</label>
          <Input
            style={{ width: 230, height: 39, borderRadius: "8px", border: "1px solid #6B43B5" }}
            onChange={handleChange}
            className={formErrorsPatient.LastName && formErrorsPatient.LastName.massage !== "" ? "inputs-error" : ""}
            type="text"
            name="patient_last_name"
            placeholder="Doe"
            value={patientLastName}
            prefix={<UserOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
          />
          {formErrorsPatient.LastName && !formErrorsPatient.LastName.status ? (
            <div className="error-text">{formErrorsPatient.LastName.massage}</div>
          ) : null}
        </Col>
      </Row>
      <Row gutter={[25, 25]} style={{ display: "flex", flexDirection: "row" }}>
        <Col span={24}>
          <label className="formLabel">Birth Date</label>
          <DatePicker
            style={{ height: 39, borderRadius: "8px", border: "1px solid #6B43B5", width: "100%" }}
            name="birth_date"
            placeholder="Enter Birth Date"
            className={formErrorsPatient && formErrorsPatient.BirthDate && formErrorsPatient.BirthDate.status ? "inputs-error" : "inputs"}
            htmlType="submit"
            onChange={handleBirthDateChange}
            value={birthDayPreview}
            suffixIcon={<img src={calendar} alt="" />}
          />
          {formErrorsPatient && formErrorsPatient.BirthDate && !formErrorsPatient.BirthDate.status && (
            <div className="error-text">{formErrorsPatient.BirthDate.message}</div>
          )}
        </Col>
      </Row>
      <Row gutter={[25, 25]} style={{ display: "flex", flexDirection: "row" }}>
        <Col span={12}>
          <label className="formLabel">Email</label>
          <Input
            style={{ width: 230, height: 39, borderRadius: "8px", border: "1px solid #6B43B5" }}
            onChange={handleChange}
            className={formErrorsPatient.Email && formErrorsPatient.Email.massage !== "" ? "inputs-error" : ""}
            name="patient_email_address"
            type="email"
            autoComplete="email"
            placeholder="Enter Email"
            value={patientEmailAddress}
          />
          {formErrorsPatient.Email && !formErrorsPatient.Email.status ? <div className="error-text">{formErrorsPatient.Email.massage}</div> : null}
        </Col>
        <Col span={12}>
          <label className="formLabel">Phone</label>
          <Input
            style={{ width: 230, height: 39, borderRadius: "8px", border: "1px solid #6B43B5" }}
            onChange={handleChange}
            className={formErrorsPatient.Phone && formErrorsPatient.Phone.massage !== "" ? "inputs-error" : ""}
            type="text"
            name="patient_phone_number"
            placeholder="Enter Phone Number"
            value={patientPhoneNumber}
          />
          {formErrorsPatient.Phone && !formErrorsPatient.Phone.status ? <div className="error-text">{formErrorsPatient.Phone.massage}</div> : null}
        </Col>
      </Row>
      <Row gutter={[25, 25]} style={{ display: "flex", flexDirection: "row" }}>
        <Col span={8}>
          <label className="formLabel">State</label>
          <Input
            style={{ width: 145, height: 39, borderRadius: "8px", border: "1px solid #6B43B5" }}
            className={formErrorsPatient.pState && formErrorsPatient.pState.massage !== "" ? "inputs-error" : ""}
            onChange={handleChange}
            type="text"
            name="patient_state"
            placeholder="Enter State"
            value={patientState}
          />
          {formErrorsPatient.pState && !formErrorsPatient.pState.status ? <div className="error-text">{formErrorsPatient.pState.massage}</div> : null}
        </Col>
        <Col span={8}>
          <label className="formLabel">City</label>
          <Input
            style={{ width: 145, height: 39, borderRadius: "8px", border: "1px solid #6B43B5" }}
            className={formErrorsPatient.City && formErrorsPatient.City.massage !== "" ? "inputs-error" : ""}
            onChange={handleChange}
            type="text"
            name="patient_city"
            placeholder="Enter City"
            value={patientCity}
          />
          {formErrorsPatient.City && !formErrorsPatient.City.status ? <div className="error-text">{formErrorsPatient.City.massage}</div> : null}
        </Col>
        <Col span={8}>
          <label className="formLabel">Postal Code</label>
          <Input
            style={{ width: 145, height: 39, borderRadius: "8px", border: "1px solid #6B43B5" }}
            className={formErrorsPatient.Zipcode && formErrorsPatient.Zipcode.massage !== "" ? "inputs-error" : ""}
            onChange={handleChange}
            type="text"
            name="Zipcode"
            placeholder="Enter Postal Code"
            value={zipcode}
          />
          {formErrorsPatient.Zipcode && !formErrorsPatient.Zipcode.status ? (
            <div className="error-text">{formErrorsPatient.Zipcode.massage}</div>
          ) : null}
        </Col>
      </Row>
      <div style={{ marginBottom: 35 }}>
        <label className="formLabel">Address</label>
        <Input
          style={{ height: 39, borderRadius: "8px", border: "1px solid #6B43B5" }}
          onChange={handleChange}
          className={formErrorsPatient.Address && formErrorsPatient.Address.massage !== "" ? "inputs-error" : ""}
          type="text"
          name="patient_address"
          placeholder="Enter Address"
          value={patientAddress}
        />
      </div>
      {formErrorsPatient.Address && !formErrorsPatient.Address.status ? <div className="error-text">{formErrorsPatient.Address.massage}</div> : null}
    </Modal>
  );
}
